import { render, staticRenderFns } from "./ReviewSetting.vue?vue&type=template&id=aab2c6d6"
import script from "./ReviewSetting.vue?vue&type=script&lang=js"
export * from "./ReviewSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports